import { render } from "./smsAuth.vue?vue&type=template&id=03563a77&scoped=true"
import script from "./smsAuth.vue?vue&type=script&lang=js"
export * from "./smsAuth.vue?vue&type=script&lang=js"

import "./smsAuth.vue?vue&type=style&index=0&id=03563a77&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03563a77"]])

export default __exports__